module.exports = "<p>\r\n  sensor-detail works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/devices/device-detail/sensor-detail/sensor-detail.component.html
// module id = ./src/app/entities/devices/device-detail/sensor-detail/sensor-detail.component.html
// module chunks = main